// Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { combineReducers } from "@reduxjs/toolkit";
import { connectorStoreApi } from "../apis/connectorApis";
import connectors from "./connectorSlice";
import connector from "./connectorInfoSlice";
import categories from "./categorySlice";
import products from "./productSlice";
import versions from "./versionSlice";
import labels from "./labelSlice";
import connectorNames from "./connectorNameSlice";
import themeReducer from "./themeSlice";

const rootReducer = combineReducers({
  connectors,
  connector,
  categories,
  labels,
  products,
  versions,
  connectorNames,
  theme: themeReducer,
  [connectorStoreApi.reducerPath]: connectorStoreApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
